import "../styles/Awareness.css";

type Props = {
  isHidden: boolean;
  handleOverLay: () => void;
};
const Awareness = (props: Props) => {
  return (
    <>
      <div className="awareness-page">
        <div className="image">
          <img
            src="https://cdn.econceptionscdn.com/Tamasha/imgs/main-img.webp"
            width={340}
            height={598}
            alt="awareness main image"
          />
        </div>
        <div
          className={`cong-overlay ${props.isHidden ? "hidden" : ""}`}
          onClick={props.handleOverLay}
        ></div>
        <div className={`cong-box ${props.isHidden ? "hidden" : ""}`}>
          <img
            src="https://cdn.econceptionscdn.com/Tamasha/imgs/yellowstar.webp"
            alt="star"
          />
          <div className="mubarakhead">Mubarak Ho!</div>
          <div className="mubaraltext">
            Aap Kamyabi k sath Tamasha Family Ka hisa ban chukay hain,
            <br /> Abhi Tamasha app download karein!
          </div>
          <div className="tamashastore">
            <a href="https://app.tamashaweb.com/JHLA" target="_blank">
              <img
                src="https://cdn.econceptionscdn.com/Tamasha/imgs/appstore.webp"
                alt="app store"
              />
            </a>
            <a href="https://app.tamashaweb.com/JHLA" target="_blank">
              <img
                src="https://cdn.econceptionscdn.com/Tamasha/imgs/google_play.webp"
                alt="google play"
              />
            </a>
          </div>
        </div>
      </div>
    </>
  );
};

export default Awareness;
